var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 6L0 6L0 19L24 19L24 6Z",
    fill: "#B22234"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.5L24 7.5L0 7.5ZM24 9.5L0 9.5L24 9.5ZM0 11.5L24 11.5L0 11.5ZM24 13.5L0 13.5L24 13.5ZM0 15.5L24 15.5L0 15.5ZM24 17.5L0 17.5L24 17.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 8L0 8L0 7L24 7V8ZM0 9L24 9V10L0 10L0 9ZM24 12L0 12L0 11L24 11V12ZM0 13L24 13V14L0 14L0 13ZM24 16L0 16L0 15L24 15V16ZM0 17L24 17V18L0 18L0 17Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 6L0 6L0 13L9.6 13L9.6 6Z",
    fill: "#3C3B6E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.799817 6.30078L1.02827 7.02439L0.430176 6.57717H1.16946L0.571366 7.02439L0.799817 6.30078Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.799817 7.69922L1.02827 8.42283L0.430176 7.97561H1.16946L0.571366 8.42283L0.799817 7.69922Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.799817 9.10156L1.02827 9.82517L0.430176 9.37796H1.16946L0.571366 9.82517L0.799817 9.10156Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.799817 10.5L1.02827 11.2236L0.430176 10.7764H1.16946L0.571366 11.2236L0.799817 10.5Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.799817 11.9023L1.02827 12.626L0.430176 12.1787H1.16946L0.571366 12.626L0.799817 11.9023Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1.59962 7L1.82807 7.72361L1.22998 7.27639H1.96926L1.37117 7.72361L1.59962 7Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1.59962 8.39844L1.82807 9.12204L1.22998 8.67483H1.96926L1.37117 9.12204L1.59962 8.39844Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.59962 9.80078L1.82807 10.5244L1.22998 10.0772H1.96926L1.37117 10.5244L1.59962 9.80078Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.59962 11.1992L1.82807 11.9228L1.22998 11.4756H1.96926L1.37117 11.9228L1.59962 11.1992Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39991 6.30078L2.62837 7.02439L2.03027 6.57717H2.76956L2.17146 7.02439L2.39991 6.30078Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39991 7.69922L2.62837 8.42283L2.03027 7.97561H2.76956L2.17146 8.42283L2.39991 7.69922Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39991 9.10156L2.62837 9.82517L2.03027 9.37796H2.76956L2.17146 9.82517L2.39991 9.10156Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39991 10.5L2.62837 11.2236L2.03027 10.7764H2.76956L2.17146 11.2236L2.39991 10.5Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39991 11.9023L2.62837 12.626L2.03027 12.1787H2.76956L2.17146 12.626L2.39991 11.9023Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.19972 7L3.42817 7.72361L2.83008 7.27639H3.56936L2.97127 7.72361L3.19972 7Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3.19972 8.39844L3.42817 9.12204L2.83008 8.67483H3.56936L2.97127 9.12204L3.19972 8.39844Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M3.19972 9.80078L3.42817 10.5244L2.83008 10.0772H3.56936L2.97127 10.5244L3.19972 9.80078Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M3.19972 11.1992L3.42817 11.9228L2.83008 11.4756H3.56936L2.97127 11.9228L3.19972 11.1992Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00001 6.30078L4.22846 7.02439L3.63037 6.57717H4.36965L3.77156 7.02439L4.00001 6.30078Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00001 7.69922L4.22846 8.42283L3.63037 7.97561H4.36965L3.77156 8.42283L4.00001 7.69922Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00001 9.10156L4.22846 9.82517L3.63037 9.37796H4.36965L3.77156 9.82517L4.00001 9.10156Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00001 10.5L4.22846 11.2236L3.63037 10.7764H4.36965L3.77156 11.2236L4.00001 10.5Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00001 11.9023L4.22846 12.626L3.63037 12.1787H4.36965L3.77156 12.626L4.00001 11.9023Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79982 7L5.02827 7.72361L4.43018 7.27639H5.16946L4.57137 7.72361L4.79982 7Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79982 8.39844L5.02827 9.12204L4.43018 8.67483H5.16946L4.57137 9.12204L4.79982 8.39844Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79982 9.80078L5.02827 10.5244L4.43018 10.0772H5.16946L4.57137 10.5244L4.79982 9.80078Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79982 11.1992L5.02827 11.9228L4.43018 11.4756H5.16946L4.57137 11.9228L4.79982 11.1992Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60011 6.30078L5.82856 7.02439L5.23047 6.57717H5.96975L5.37166 7.02439L5.60011 6.30078Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60011 7.69922L5.82856 8.42283L5.23047 7.97561H5.96975L5.37166 8.42283L5.60011 7.69922Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60011 9.10156L5.82856 9.82517L5.23047 9.37796H5.96975L5.37166 9.82517L5.60011 9.10156Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60011 10.5L5.82856 11.2236L5.23047 10.7764H5.96975L5.37166 11.2236L5.60011 10.5Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60011 11.9023L5.82856 12.626L5.23047 12.1787H5.96975L5.37166 12.626L5.60011 11.9023Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39991 7L6.62837 7.72361L6.03027 7.27639H6.76956L6.17146 7.72361L6.39991 7Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39991 8.39844L6.62837 9.12204L6.03027 8.67483H6.76956L6.17146 9.12204L6.39991 8.39844Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39991 9.80078L6.62837 10.5244L6.03027 10.0772H6.76956L6.17146 10.5244L6.39991 9.80078Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39991 11.1992L6.62837 11.9228L6.03027 11.4756H6.76956L6.17146 11.9228L6.39991 11.1992Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19972 6.30078L7.42817 7.02439L6.83008 6.57717H7.56936L6.97127 7.02439L7.19972 6.30078Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19972 7.69922L7.42817 8.42283L6.83008 7.97561H7.56936L6.97127 8.42283L7.19972 7.69922Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19972 9.10156L7.42817 9.82517L6.83008 9.37796H7.56936L6.97127 9.82517L7.19972 9.10156Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19972 10.5L7.42817 11.2236L6.83008 10.7764H7.56936L6.97127 11.2236L7.19972 10.5Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19972 11.9023L7.42817 12.626L6.83008 12.1787H7.56936L6.97127 12.626L7.19972 11.9023Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99952 7L8.22798 7.72361L7.62988 7.27639H8.36917L7.77107 7.72361L7.99952 7Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99952 8.39844L8.22798 9.12204L7.62988 8.67483H8.36917L7.77107 9.12204L7.99952 8.39844Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99952 9.80078L8.22798 10.5244L7.62988 10.0772H8.36917L7.77107 10.5244L7.99952 9.80078Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99952 11.1992L8.22798 11.9228L7.62988 11.4756H8.36917L7.77107 11.9228L7.99952 11.1992Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79982 6.30078L9.02827 7.02439L8.43018 6.57717H9.16946L8.57137 7.02439L8.79982 6.30078Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79982 7.69922L9.02827 8.42283L8.43018 7.97561H9.16946L8.57137 8.42283L8.79982 7.69922Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79982 9.10156L9.02827 9.82517L8.43018 9.37796H9.16946L8.57137 9.82517L8.79982 9.10156Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79982 10.5L9.02827 11.2236L8.43018 10.7764H9.16946L8.57137 11.2236L8.79982 10.5Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79982 11.9023L9.02827 12.626L8.43018 12.1787H9.16946L8.57137 12.626L8.79982 11.9023Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "static/media/usa.d1478c693cb2f7154be478707b9e4ee9.svg";
export { ForwardRef as ReactComponent };